(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('AcuityController', AcuityController);

    AcuityController.$inject = ['GenericEntityDatatableService', 'CoreService', 'Acuity', '$uibModal',
        '$q', 'ConfirmationService'];

    function AcuityController(GenericEntityDatatableService, CoreService, Acuity, $uibModal,
                              $q, ConfirmationService) {
        var vm = this;

        var params = CoreService.getFilterByCurrentCorporation();

        vm.descriptor = {
            title: 'Acuities',
            newButtonTitle: 'New Acuity',
            entityClassHumanized: 'Acuities',
            entityStateName: 'acuity',
            service: Acuity,
            serviceMethod: 'findAllByCorporation',
            params: params,
            newAction: false,
            columns: [
                {
                    name: 'name',
                    title: 'Name',
                }
            ],
            rowActions: [
                angular.extend({}, GenericEntityDatatableService.getEditAction(), {
                    action: function (data) {
                        return edit(data.id);
                    }
                }),
                angular.extend({}, GenericEntityDatatableService.getDeleteAction(), {
                    action: function (data) {
                        return del(data.id);
                    }
                }),
            ],
            actions: [
                {
                    type: 'group',
                    buttons: [
                        angular.extend({}, GenericEntityDatatableService.getNewAction(), {
                            name: 'New Acuity',
                            action: function () {
                                return add();
                            }
                        })
                    ]
                }
            ],
        }

        function add() {
            return $uibModal.open({
                templateUrl: 'app/entities/acuity/update/acuity-dialog.html',
                controller: 'AcuityDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                windowTopClass: 'custom-dialog-styles',
                size: 'md',
                resolve: {
                    entity: ['CoreService', function (CoreService) {
                        return {
                            name: null,
                            id: null,
                            corporation: CoreService.getCorporation()
                        };
                    }]
                }
            }).result;
        }

        function edit(id) {
            return $uibModal.open({
                templateUrl: 'app/entities/acuity/update/acuity-dialog.html',
                controller: 'AcuityDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    entity: ['Acuity', function (Acuity) {
                        return Acuity.get({id: id}).$promise;
                    }]
                }
            }).result;
        }

        function del(id) {
            return $q(function (resolve) {
                ConfirmationService.showDelete('Acuity').result.then(function () {
                    Acuity.delete({id: id}, function () {
                        return resolve();
                    });
                })
            });
        }
    }
})();
